// extracted by mini-css-extract-plugin
export default {"logoContainer":"Icons_logoContainer__SFB7A"};